import { useMemo } from 'react';

export interface DenialBranding {
	supportEmail: string | null;
	supportUrl: string | null;
	supportLabel: string;
}

/**
 * Resolves tenant-aware support contact from BFF branding configuration.
 * Prefers plugin-specific support_email, then falls back to branding footer links.
 * Returns nulls if no real contact is configured -- callers should hide contact
 * buttons rather than showing a placeholder.
 */
export function useDenialBranding(pluginSupportEmail?: string): DenialBranding {
	return useMemo(() => {
		if (pluginSupportEmail) {
			return {
				supportEmail: pluginSupportEmail,
				supportUrl: null,
				supportLabel: 'Contact Plugin Support',
			};
		}

		const branding = (globalThis as any).__EXPERIENCE_BRANDING__;
		if (branding?.footer?.links) {
			const supportLink = branding.footer.links.find(
				(l: any) => typeof l?.label === 'string' && l.label.toLowerCase().includes('support') && l.url,
			);
			if (supportLink) {
				const isEmail = supportLink.url.startsWith('mailto:');
				return {
					supportEmail: isEmail ? supportLink.url.replace('mailto:', '') : null,
					supportUrl: isEmail ? null : supportLink.url,
					supportLabel: supportLink.label || 'Contact Support',
				};
			}
		}

		return { supportEmail: null, supportUrl: null, supportLabel: 'Contact Support' };
	}, [pluginSupportEmail]);
}
